import { Box } from "@chakra-ui/react";
import React from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { PageWrapperHero } from "./style";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./components/ErrorFallback";

interface IProps {
  children: React.ReactNode;
}

const PageWrapper: React.FC<IProps> = ({ children, ...props }) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <PageWrapperHero>
        <Header />
        <Box {...props}>{children}</Box>
        <Footer />
      </PageWrapperHero>
    </ErrorBoundary>
  );
};

export default PageWrapper;
